import service from '@/services/types/provincia'
// import VuexPersistence from 'vuex-persist'

// const vuexLocal = new VuexPersistence({
//    storage: window.localStorage
// })

export const namespaced = true

export const state = () => ({
  list: []
})

export const mutations = {
  LIST: (state, objs) => (state.list = objs)
}

export const actions = {
  list: ({ commit, state }, value) => {
    if (state.list?.length) {
      console.log('provicias from cache ⏩')
      return state.list
    } else {
      console.log('provicias from api 😮🥵')
      return service.list(value).then(result => commit('LIST', result) || result)
    }
  }
}

//  export const plugins = [vuexLocal.plugin]
